import { z } from 'zod';

import { Role } from '@app/utils/protected-routes.utils';

export const CreateUserSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(1, 'First name is required')
    .max(30, 'First name cannot be longer than 30 characters'),
  lastName: z.string().trim().min(1, 'Last name is required').max(30, 'Last name cannot be longer than 30 characters'),
  email: z.email('Invalid email address').max(50, 'Email cannot be longer than 50 characters'),
  roleId: z
    .string()
    .min(1, 'Please select a role')
    .refine((val) => Object.values(Role).includes(val as Role), {
      message: 'Invalid role selected',
    }),
});

export type CreateUserFormValues = z.infer<typeof CreateUserSchema>;
